import {ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit} from '@angular/core';
import {filter, take} from 'rxjs/operators';
import {AdvertService} from './advert.service';
import {Store} from '@ngxs/store';
import {PlayerState} from '../../store/player.state';
import {SetVolume} from '../../store/player.actions';

@Component({
  selector: 'gg-advert',
  template: '<div></div>',
  styleUrls: ['./advert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdvertComponent implements OnInit {
  private adsModule: any;
  private apiData: any = {};
  private elem: HTMLDivElement;
  private volume = 0;

  constructor(private elementRef: ElementRef, private advert: AdvertService, private store: Store) {
    this.init();
    this.advert.advert$.subscribe(() => this.showAdvert());
  }

  ngOnInit() {
    this.elem = this.elementRef.nativeElement.firstChild;
  }

  private async init() {
    let AdsMod;
    try {
      AdsMod = window['require']('goodgame.adsmod');
    } catch (e) {
    }

    if (!AdsMod) {
      return false;
    }
    this.adsModule = new AdsMod();

    this.apiData = await this.store.select(state => state.player.apiData).pipe(filter(data => data), take(1)).toPromise();
    this.config();
  }

  private async getCurrentVolume() {
    return this.store.select(state => state.player.volume).pipe(take(1)).toPromise();
  }

  private async config() {
    const adsMod = this.adsModule;
    const elem = this.elem;

    adsMod.setConfig({
      channelId: this.apiData.channel_id,
      channelName: this.apiData.streamer_name,
      container: elem,
      volume: await this.getCurrentVolume(),
      preset: 'ok',
      hidden: this.apiData.hidden,
    });
    adsMod.elem = elem;

    adsMod.on('started', () => this.onAdvertStarted());
    adsMod.on('ended', () => this.onAdvertEnded());
  }

  private async onAdvertStarted() {
    this.elem.style.display = 'block';
    this.volume = await this.getCurrentVolume();
    this.store.dispatch(new SetVolume({volume: 0}));
  }

  private async onAdvertEnded() {
    this.elem.style.display = 'none';
    this.store.dispatch(new SetVolume({volume: this.volume}));
  }

  private async showAdvert() {
    this.adsModule.setVolume(await this.getCurrentVolume());
    this.adsModule.showAd();
  }
}
